module.exports = __webpack_public_path__ + "static/media/news-second.a8dcae8d.mp3";